<template>
  <div class="flex flex-row items-end gap-1">
    <span v-if="hasDiscountStyle" :class="[`text-xs font-normal line-through`]">
      {{ priceDisplay(originalPrice, lang, false) }}
    </span>

    <span :class="[`text-sm font-medium`, hasDiscountStyle && `text-theme-3b`]">
      <template v-if="hasDiscountStyle && discount">
        {{ priceDisplay(discount?.discount_price, lang, false) }}
      </template>

      <template v-else>
        {{ priceDisplay(originalPrice, lang, false) }}
      </template>
    </span>
  </div>
</template>

<script lang="ts" setup>
import { getUnicodeBCP47 } from "@/locales/shared";
import { computed } from "vue";
import { universalStorage } from "@/utils/universal-storage";
import { Price, priceDisplay } from "@/features/pricing/components/IAIPrice/IAIPrice.vue";

interface Props {
  originalPrice: Price;
  discount?: {
    discount_price: Price;
    discount_percentage: number;
  };
}

const props = defineProps<Props>();
const lang = getUnicodeBCP47();

const { mobile_or_desktop } = universalStorage.getAll();

const hasDiscountStyle = computed(() => {
  return props.discount && mobile_or_desktop === "desktop";
});
</script>
